import React from 'react';
import PropTypes from 'prop-types';
import { Form, Checkbox } from 'semantic-ui-react';

import { ReduxFormField, ReduxFormFieldCheckPopup } from 'components';

const renderField = ({ input, meta, checkType, validate, warn, ...rest }) => {
  return (
    <Form.Field>
      <Checkbox
        name={input.name}
        {...rest}
        onChange={(e, data) => {
          input.onChange(data.checked ? 1 : 0);
        }}
        checked={!!input.value ? true : false}
      />
      <ReduxFormFieldCheckPopup checkType={checkType} {...meta} />
    </Form.Field>
  );
};

const ReduxFormSemanticCheckBox = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormSemanticCheckBox.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  checkType: PropTypes.number
};
ReduxFormSemanticCheckBox.defaultProps = {
  checkType: 99
};

export default ReduxFormSemanticCheckBox;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormSemanticCheckBox.js